var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 46,
  viewBox: "0 0 45 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 24.875C26.25 26.9461 24.5711 28.625 22.5 28.625C20.4289 28.625 18.75 26.9461 18.75 24.875C18.75 22.8039 20.4289 21.125 22.5 21.125C24.5711 21.125 26.25 22.8039 26.25 24.875Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.75 16.1419C3.75 13.5607 5.50667 11.3108 8.01074 10.6848L11.25 9.875L13.8868 5.91987C14.5822 4.87663 15.7531 4.25 17.0069 4.25H27.9931C29.2469 4.25 30.4178 4.87663 31.1132 5.91987L33.75 9.875L36.9893 10.6848C39.4933 11.3108 41.25 13.5607 41.25 16.1419V36.125C41.25 39.2316 38.7316 41.75 35.625 41.75H9.375C6.2684 41.75 3.75 39.2316 3.75 36.125V16.1419ZM35.625 17.375C35.625 18.4105 34.7855 19.25 33.75 19.25C32.7145 19.25 31.875 18.4105 31.875 17.375C31.875 16.3395 32.7145 15.5 33.75 15.5C34.7855 15.5 35.625 16.3395 35.625 17.375ZM30 24.875C30 29.0171 26.6421 32.375 22.5 32.375C18.3579 32.375 15 29.0171 15 24.875C15 20.7329 18.3579 17.375 22.5 17.375C26.6421 17.375 30 20.7329 30 24.875Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 24.875C26.25 26.9461 24.5711 28.625 22.5 28.625C20.4289 28.625 18.75 26.9461 18.75 24.875C18.75 22.8039 20.4289 21.125 22.5 21.125C24.5711 21.125 26.25 22.8039 26.25 24.875Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.3125 4.25L40.3125 9.875",
  stroke: "white",
  strokeWidth: 0.879032,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5001 7.0625L43.1251 7.0625",
  stroke: "white",
  strokeWidth: 0.879032,
  strokeLinecap: "round"
})));
export default SvgCamera;